// Gmail 送信用トークンの「アカウント検証」まわりの純粋ロジック。
// GIS・ネットワークに依存しないため単体テスト可能（gmailTokenCore.test.js）。

// 期限の60秒手前で失効扱いにし、ギリギリのトークンでの送信失敗を防ぐ。
export const EXPIRY_SKEW_MS = 60 * 1000;

/** メールアドレスを比較用に正規化する（不正値は null）。 */
export const normalizeEmail = (email) =>
  typeof email === "string" && email.trim() !== ""
    ? email.trim().toLowerCase()
    : null;

/** 2つのメールアドレスが同一アカウントを指すか。 */
export const emailsMatch = (a, b) => {
  const na = normalizeEmail(a);
  const nb = normalizeEmail(b);
  return na !== null && na === nb;
};

/**
 * キャッシュ済みトークンを送信ユーザに対して再利用してよいか。
 * トークンの実アカウント (cache.email) と送信ユーザの一致を必須とする。
 * @param {{token: string, expiry: number, email: string}|null} cache
 * @param {string} senderEmail 送信ユーザのメールアドレス
 * @param {number} now 現在時刻 (ms)
 */
export const isCacheUsable = (cache, senderEmail, now) =>
  Boolean(
    cache &&
      cache.token &&
      cache.email &&
      emailsMatch(cache.email, senderEmail) &&
      now < cache.expiry - EXPIRY_SKEW_MS
  );

/**
 * トークンの実アカウントが送信ユーザと一致しない場合のエラー（送信中止）。
 * 呼び出し側は e.name === "AccountMismatchError" で判定する
 * （トランスパイル環境でも instanceof に依存しないため）。
 */
export class AccountMismatchError extends Error {
  constructor(actualEmail, expectedEmail) {
    super(
      `Google アカウント (${actualEmail}) が送信ユーザ (${expectedEmail}) と一致しません`
    );
    this.name = "AccountMismatchError";
    this.actualEmail = actualEmail;
    this.expectedEmail = expectedEmail;
  }
}

/** トークンの実アカウント確認 (userinfo) に失敗した場合のエラー（送信中止）。 */
export class TokenVerificationError extends Error {
  constructor(cause) {
    super("Google アカウントの確認に失敗しました");
    this.name = "TokenVerificationError";
    this.cause = cause;
  }
}
